<script setup lang="ts">
import SidebarMenuSection from "./SidebarMenuSection.vue";
import { LogoIcon } from "@/ui-kit/icons";
import { IconExitRegular, IconUserRegular } from "@packages/icon-library";
import { NAVIGATION } from "@/modules/sideBarMenu";
import SideBarButton from "./SideBarButton.vue";
import { useAuthStore } from "@/store/auth.store";
import { storeToRefs } from "pinia";

const emit = defineEmits(["newPath"]);

const { logout } = useAuthStore();

const { user } = storeToRefs(useAuthStore());
</script>

<template>
  <aside class="side-bar-menu">
    <header class="side-bar-menu__header header">
      <RouterLink class="header__logo" to="/">
        <LogoIcon />
        rc market
      </RouterLink>
    </header>
    <nav class="side-bar-menu__nav">
      <SidebarMenuSection
        v-for="(item, idx) in NAVIGATION"
        :key="idx"
        :item="item"
        :user="user"
        @newPath="emit('newPath', $event)"
      />
    </nav>
    <footer v-if="user" class="side-bar-menu__footer footer">
      <span class="footer__user">
        <IconUserRegular class="footer__icon" />
        <span class="footer__text">
          {{ user.first_name }} {{ user.last_name }}
        </span>
      </span>
      <SideBarButton @click="logout">
        <IconExitRegular class="footer__icon" />
      </SideBarButton>
    </footer>
  </aside>
</template>

<style lang="scss" scoped>
.side-bar-menu {
  position: fixed;
  width: 260px;
  height: 100%;
  padding: 8px 8px 70px;
  background: var(--color-semantic-background-normal-bg-secondary);
  border-right: 1px solid var(--color-semantic-border-normal-soft);

  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 260px;
    padding: 16px;
    background: var(--color-semantic-background-normal-bg-secondary);
    border-right: 1px solid var(--color-semantic-border-normal-soft);

    &__logo {
      display: flex;
      gap: 8px;
      align-items: center;
      width: fit-content;
      color: var(--color-semantic-content-normal-primary);
      text-transform: uppercase;
      transition: opacity 0.3s ease-out;

      @include body-bold-M;

      @media (hover: hover) {
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 260px;
    padding: 16px;
    background: var(--color-semantic-background-normal-bg-secondary);
    border-right: 1px solid var(--color-semantic-border-normal-soft);

    &__icon {
      width: 20px;
      height: 20px;
      background: var(--color-semantic-content-normal-tertiary);
    }

    &__user {
      display: flex;
      flex-wrap: nowrap;
      gap: 8px;
      align-items: center;
    }

    &__text {
      overflow: hidden;
      color: var(--color-semantic-content-normal-primary);
      white-space: nowrap;

      @include control-S;
    }
  }

  &__nav {
    height: 100%;
    margin-top: 64px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
